import Env from '../base/env';
import Channels from '../base/channels';
import gsap from 'gsap';
import { module } from 'modujs';

export default class extends module {
  constructor(m) {
    super(m);
  }

  destroy() {
    this.st.kill();
    Channels.removeListener('launcher::exit', this.funcLaunch);
    Channels.removeListener('transition::end', this.funcLaunch);
  }

  init() {
    this.DOM = {
      view: this.el,
    };

    //! Fns
    this.funcLaunch = this._fx.bind(this);
    Channels.on('launcher::exit', this.funcLaunch);
    Channels.on('transition::end', this.funcLaunch);
  }

  _fx() {
    const delay = Env.isVisiting ? 0.3 : 0.1;
    gsap.delayedCall(delay, () => {
      this.reveal();
    });
  }

  reveal() {
    this.tl = gsap.timeline();

    gsap.delayedCall(0.5, () => {
      Env.$html.classList.add('purchase-bar-show');
    });
    this.tl.add([
      gsap.fromTo(
        this.$('curtain'),
        {
          scaleY: 1,
          // transformOrigin: 'top center',
        },
        {
          scaleY: 0,
          ease: 'quint.inOut',
          duration: 1,
          stagger: 0.1,
        }
      ),
      gsap.fromTo(
        this.$('picture'),
        {
          scale: 1.1,
        },
        {
          scale: 1.01,
          ease: 'cubic.out',
          duration: 1,
          stagger: 0.1,
        }
      ),
    ]);
  }
}
